import styled from 'styled-components';

export const ButtonsList = styled.div`
  display: flex;
  gap: 16px;
  flex-wrap: wrap;
`;
